<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :inline="true" :rules="rules">
        <div class="block">
          <div class="contit">基础信息</div>
          <!-- 选择车牌按钮 -->
          <VehicleSelect :modalList="cars" @onChecked="onChecked">
            <template #start>
              <div class="sinput">
                <SearchField :form="sform" :formCtrl="sformCtrl" @onSearch="onSearch" @onReset="onModalReset" @onChange="onSearchItemChange" />
              </div>
            </template>
          </VehicleSelect>
          <!-- 其他控件 -->
          <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">运单信息</div>
          <FormItem v-for="(c, i) in formCtrlOrder.slice(0, 3)" :key="'formItemo1' + i" :viewMode="c.viewMode"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
            
          <div>
            <FormItem v-for="(c, i) in formCtrlOrder3" :key="'formO2Item2' + i" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </div>

          <!-- 装卸货量和亏吨 -->
          <div v-show="form.pricing_id != 5">
            <FormItem v-for="(c, i) in formCtrlOrder.slice(3)" :key="'formItemO3' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

            <!-- 亏吨重量控件 -->
            <span>
              <FormItem v-show="form.pricing_id == 1" :viewMode="kuitonCtrl.viewMode" :config="kuitonCtrl"
                :options="kuitonCtrl.options" :inputValue="form[kuitonCtrl.keyName]" @onChange="onChange" />
            </span>
          </div>

          <div>
            <FormItem v-for="(c, i) in formCtrlOrder2" :key="'formO2Item' + i" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </div>
          <!-- 重量控件 -->
          <span v-show="form.pricing_id == 1">
            <FormItem v-for="(c, i) in formCtrlWeight" :key="'formItemWeight' + i" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </span>
        </div>

        <div class="block">
          <div class="contit">备注信息</div>
          <FormItem v-for="(c, i) in formCtrlTime" :key="'form2Item' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange">
            <template #end>
              <!-- 结款提醒组件 -->
              <PaymentSwitch v-show="form['repaytime']" :value="form['istime']" @onToggle="onToggle" />
            </template>
          </FormItem>

          <!-- 可变文本域备注 -->
          <FormItem v-for="(c, i) in formCtrl3" :key="'form3Item' + i" :ref="'form3Item' + i" :viewMode="c.viewMode"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput">
          </FormItem>
        </div>

        <ExtraFee :form="form" :formCtrl="formCtrlfee" @onChange="onChange" />
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import orderViewMixin from "../orderViewMixin";
import hireMixin from "../hireMixin";

export default {
  mixins: [detailMixin, orderViewMixin, hireMixin],
  data() {
    return {
      breadcrumb: [
        { name: "运单管理", path: "/order/contract" },
        { name: "合同运单", path: "/order/contract/hire" },
        { name: "合同外协运单添加" },
      ],
      formCtrlOrder3: [
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          className: "unton",
          viewMode: true,
        },
        {
          ...this.ctrls.ZhuangHuoRiQi,
        },
        {
          ...this.ctrls.XieHuoRiQi,
        },
      ],
      formCtrl: [
        // {
        //   label: "承运公司",
        //   keyName: "pcustomname",
        //   err: "请填写承运公司",
        //   type: "text",
        //   viewMode: true,
        // },
        {
          label: "合同编号",
          keyName: "contractid",
          err: "请选择合同编号",
          type: "select",
          options: [],
        },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "text",
          viewMode: true,
        },
        {
          label: "货物名称",
          keyName: "name",
          err: "请选择货物名称",
          type: "text",
          viewMode: true,
        },
      ],
      form: {
        license: '',
        predict_loading_date: '',
        predict_unloading_date: '',
        name: '',
        cmessage: null,
        shipperid: '',
        pcustomname: '',
        coaddress: '',
        enaddress: '',
        inton: null,
        unton: null,
        invoice: null,
        uninvoice: null,
        cprice: null,
        dprice: null,
        dtonprice: null,
        insurance: null,
        fuel: null,
        exceeded: null,
        pricing_id: null,
        contractid: null,
      },
      rules: {
        predict_loading_date: [
          { required: true, message: "请选择装货日期", trigger: "blur" },
        ],
        predict_unloading_date: [
          { required: true, message: "请选择卸货日期", trigger: "blur" },
        ],
        contractid: [
          { required: true, message: "请选择合同编号", trigger: "blur" },
        ],
        pricing_id: [
          { required: true, message: "请选择计价方式", trigger: "blur" },
        ],
        license: [
          { required: true, message: "请选择车牌号", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请选择货物名称", trigger: "blur" },
        ],
        shipperid: [
          { required: true, message: "请填写客户名称", trigger: "blur" },
        ],
        coaddress: [
          { required: true, message: "请填写装货地址", trigger: "blur" },
        ],
        enaddress: [
          { required: true, message: "请填写卸货地址", trigger: "blur" },
        ],
        inton: [
          { required: true, validator: this.checkInTon, trigger: "blur" },
        ],
        unton: [
          { required: true, validator: this.checkUnTon, trigger: "blur" },
        ],
        invoice: [
          { required: true, message: "请上传装货单", trigger: "blur" },
        ],
        uninvoice: [
          { required: true, message: "请上传卸货单", trigger: "blur" },
        ],
        cprice: [
          { required: true, message: "请填写公司单价", trigger: "blur" },
        ],
        dprice: [
          { required: true, message: "请填写司机单价", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    onChange({ key, value }) {
      console.log(key, value)
      // console.log(Number(value))
      if (key.includes('additional_fee')) {
        this.ExtraFeeChange(key, value)
      } else if (key === 'contractid') {
        this.$set(this.form, key, value)
        this.contract.map(v => {
          if (value === v.id) {
            this.$set(this.form, 'shname', v.shname)
            this.$set(this.form, 'shipperid', v.shipperid)
            this.$set(this.form, 'name', v.name)
            this.$set(this.form, 'nid', v.nid)
            this.$set(this.form, 'pricing_id', v.pricing_id)
            this.setPricingName(v.pricing_id)
            this.$set(this.form, 'cprice', v.cprice)
            this.$set(this.form, 'coaddress', v.coaddress)
            this.$set(this.form, 'enaddress', v.enaddress)
            // console.log({...v})
          }
        })
      } else if (['invoice', 'uninvoice'].includes(key) && value && value[0].response) {
        this.$set(this.form, key, value[0].response.photo)
      } else if (key === 'shipperid') {
        this.$set(this.form, key, value)
        if (this.pcustom && this.pcustom.length) {
          this.pcustom.map(v => {
            if (value === v.id) {
              this.$set(this.form, 'shname', v.name)
              // console.log({...v})
            }
          })
        }
      } else {
        this.$set(this.form, key, value)
      }
      // 表单赋值之后再计算亏吨重量
      if (['inton', 'unton'].includes(key)) {
        this.calcKuiton()
      }
      // console.log('form', { ...this.form });
    },
  },
  created() {
    // this.rules['contractid'] = [
    //   { required: true, message: "请选择合同编号", trigger: "blur" },
    // ]
    //计价方式和运费单价不可修改
    this.formCtrlOrder.map(c => {
      if (c.keyName == 'pricing_name' || c.keyName == 'cprice') {
        c.viewMode = true
      }
    })
    // console.log(this.formCtrlOrder)
  },
  mounted() {
    // console.log('form', { ...this.form })
    // console.log('formCtrl', [...this.formCtrl])
  },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.choose {
        display: flex;

        .el-form-item__content {
          flex: 1;
        }
      }

      &.br {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: '关';
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: '开';
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;
}

/deep/ .sinput {
  .fillet {
    padding: 0;
    box-shadow: none;
  }

  .retrieval {
    margin: 0;

    .el-form-item__content {
      .el-input {
        width: 150px !important;
      }
    }

    .el-form {
      margin-bottom: 0px !important;
    }

    .el-form-item {
      margin: 0 0 10px 0;
    }
  }



}
</style>
